import React from 'react'
//css
import "./Mechanicalprojects.css"
//link
import { Link } from 'react-router-dom'

//assets2 link 
import image from "../../assets2/nwimage1.png"
//import image from "../../assets2/nimage2.jpg"

import image2 from "../../assets2/nwimage4.jpeg"

const Mechanicalprojects = () => {
  return (
       <div className='overallmech'>
         <h1 className='evhead1'>Wireless power transfer (EV)</h1>
         <p className='evpara1'>Wireless Power Transfer (WPT) technology is revolutionizing 
            the way electric vehicles (EVs) are charged, eliminating the 
            need for physical cables. Using inductive or resonant coupling,
            energy is transferred wirelessly between a charging pad on 
             the ground and a receiver in the EV. This enhances convenience, safety, and efficiency by enabling 
             seamless charging at parking spots, highways, and smart roads. WPT systems reduce wear and tear 
             on charging connectors, making them more durable and low-maintenance. Dynamic wireless charging 
             allows EVs to charge while in motion, extending range without stopping. Advanced power electronics
              with renewable energy sources further enhances sustainability. WPT technology is a step towards a
              smarter, more connected, and eco-friendly transportation system</p>
        
        <div className='mechimg'>
         <img src={image} alt="" className='mechinnerimg' />
        </div>
        
        <div className='content2mech' data-aos="fade-left">
          <h1 className='evhead2'>Six axis robotic arm</h1>
          <p className='evpara2'>Our Six-Axis Robotic Arm is designed for high-precision automation, offering exceptional flexibility and control across multiple industries. With six degrees of freedom (DOF), it enables complex motion, including rotation, bending, and extension, to perform intricate tasks with accuracy.
         Equipped with servo motors and advanced kinematics, the robotic arm ensures smooth and precise movement, optimizing productivity in manufacturing, assembly, welding, and material handling applications. It features inverse kinematics algorithms for seamless trajectory planning and real-time motion control.
        </p>
       
       <p className='evpara2'>Our robotic arm integrates with AI-based vision systems, allowing adaptive learning and object recognition for intelligent automation. With Ethernet, CAN, and Modbus connectivity, it supports seamless industrial communication.
       Built with lightweight yet durable materials, it offers high payload capacity while maintaining operational efficiency. The system is fully programmable via ROS (Robot Operating System) and can be customized for specific industrial applications, ensuring enhanced precision, reliability, and performance in modern automation.
       </p>
       <div className='mechimg'data-aos="fade-left" >
        <img src={image2} alt="" className='mechinnerimg'/>
       </div>
        </div>
        
        <div className='hrbtns'>
          <hr />
        <button  className='buttonforlink'><Link to="/projects" className='spllink2'>Back to projects</Link></button>
       </div>
    </div>
   
  )
}

export default Mechanicalprojects